<template>
	<div>
		<h1>Gérer les catégorie des tags</h1>

        <b-card v-for="(tag, keys) in tags" :key="keys">
            <p><strong>{{tag.id}}</strong></p>
            <p>Nom : <input v-model="tag.type" /></p>
            <p>
                <span>Colonne : </span>
                <input type="checkbox" v-model="tag.column"/>
            </p>
        </b-card>

        <br />
        <p>Nouveau type : <input v-model="type" /> <b-button variant="link" @click="add">Ajouter</b-button></p>

		<b-button @click="save" class="mt-2">Sauvegarder</b-button>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	
	export default {
        name: "tags",
		components: {
		},
		data: function () {
			return {
                type: "",
				tags: {}
			};
		},
		methods: {
            add()
            {
                this.tags[this.type] = {
                    "id": this.type,
                    "type": this.type,
                    "column": true,
                    "color": "#a6a696"
                };
                this.type = "";
            },
			async save() {
				await client.put(null, null, null, null, null, null, null, this.tags);

				this.$notify({
					group: "info",
					title: "Configuration des tags sauvegardé",
					type: "success",
				});
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.tags) {
				this.$router.push({ name: "profile" });
            }
            
            let response = await users.getSelf(true);
            this.client = response.client;
            
            if (this.client.details && this.client.details.tags)
                this.tags = this.client.details.tags;
            else
            {
                this.tags = {
                    "tag": {
                        "id": "tag",
                        "type": "Tag",
                        "color": "#a6a696",
                        "column": true,
                    }
                }
            }
		},
	};
</script>

<style></style>
